import { render, staticRenderFns } from "./InHospital.vue?vue&type=template&id=fd576054&scoped=true"
import script from "./InHospital.vue?vue&type=script&lang=js"
export * from "./InHospital.vue?vue&type=script&lang=js"
import style0 from "./InHospital.vue?vue&type=style&index=0&id=fd576054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd576054",
  null
  
)

export default component.exports